import { useMounted } from 'common/useMounted';
import { useAtomValue, WritableAtom } from 'jotai';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Set the page search params based on the URLSearchParams the atom returns
 */
export const useFilterToUrlParser = (
  {
    urlSearchParamsAtom,
  }: {
    urlSearchParamsAtom: WritableAtom<URLSearchParams, [urlSearchParams: URLSearchParams], void>;
  },
  enabled: boolean = true,
) => {
  const serachParams = useAtomValue(urlSearchParamsAtom);

  const isMounted = useMounted();

  const [, setSearhParams] = useSearchParams();

  useEffect(() => {
    if (isMounted && enabled) {
      setSearhParams(serachParams, { replace: true });
    }
  }, [serachParams]);
};
